import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import React, { Component } from "react";
import Magnifier from "react-magnifier";
import * as Render from "../util/Render";
import * as Util from "../util/util";

class PopupImage extends Component {

    constructor() {
        super();
        this.state = { imageWidth: 16, imageHeight: 9 };
    }

    imageWidth = () => {
        const { imageWidth, imageHeight } = this.state;
        if (imageHeight === 0) return "auto";
        return `calc((100vh - 140px) / ${imageHeight} * ${imageWidth})`;
    };


    componentDidUpdate(prevProps, a, b) {
        if (prevProps.url != this.props.url) {
            this.checkAspect();
        }
    }

    componentDidMount() {
        this.checkAspect();
    }

    checkAspect = () => {
        const img = new Image();
        img.onload = () => {
            this.setState({ imageWidth: img.naturalWidth, imageHeight: img.naturalHeight });
        };
        img.src = this.props.url;
    };


    render() {

        let buttons = <div style={{ margin: 12, color: "white", background: "rgba(0,0,0,0.5)", fontSize: 48 }}
            className="hoverable">

            {this.props.canDelete && <i className="material-icons" style={{ padding: 8 }} onClick={this.props.deleteImage}>delete</i>}
            <i className="material-icons" style={{ padding: 8 }} onClick={this.saveImage}>save</i>
            <i className="material-icons" style={{ padding: 8 }} onClick={this.props.close}>clear</i>
        </div>;

        let f = Render.rawOverlay(<div style={{
            height: "calc(100vh - 140px)",
            width: this.imageWidth(),
            background: "black",
            border: "4px solid " + window.primary,
            borderRadius: 16,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden"
        }}>

            {this.renderImage()}


            <div style={{
                position: "absolute",
                right: 0,
                top: 0,
                display: "flex",
                zIndex: 10000
            }}>
                {buttons}
            </div>

        </div>);


        let s = Render.rawOverlay(<div style={{ height: "100vh", width: "100vw", background: "rgba(0,0,0,0.7)" }} />);
        return [s, f];
    };

    renderImage = () => {
        if (this.props.url == "loading") {
            return <div style={{
                width: "100%",
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <CircularProgress size={100} thickness={2} />
            </div>;
        }
        return <Magnifier
            style={{
                width: "100%",
                flex: 1,
                objectFit: "contain"
            }}
            src={this.props.url}
            mgWidth={500}
            mgHeight={500}
            zoomFactor={1.2}
            mgShape="square"
        />
    };

    saveImage = () => {
        window.open(Util.download(this.props.url), "_blank");
    };


}


export default PopupImage;
